// # #############################################
// # Title : Horizontal Bar Chart
// # Authors : Rohit, Sanjay, Shubham, Annoop
// # Date : 15th October 2019
// # Last Modified : July 2019
// # Version : 19.10.03
// # Description : Code to render a horizontal bar chart ( reusable component )
// # ############################################


// Import the required Libraries

import React, { Component } from "react";
import Highcharts from "highcharts";
import config from "../utils/config";

class HorizontalbarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [], // default data
      title: null,
      colors: ["#2f32d1", "#EFE093", "#E1B675", "#DFA58B", "#D8CFAB", "#A7A19E", "#D3DB8D"], // default colors
      addOns: [
        {
          name: 'YourBrand',
          addOns: [
            "YbProbiotic", "Fat-free", "Extra Caffiene", "Added Artificial Flavour"
          ]
        },
        {
          name: 'Competitor_1',
          addOns: [
            "C1Probiotic", "Fat-free", "Extra Caffiene", "Added Artificial Flavour"
          ]
        },
        {
          name: 'Competitor_2',
          addOns: [
            "C2Probiotic", "Fat-free", "Extra Caffiene", "Added Artificial Flavour"
          ]
        },
        {
          name: 'Competitor_3',
          addOns: [
            "C2Probiotic", "Fat-free", "Extra Caffiene", "Added Artificial Flavour"
          ]
        },
        {
          name: 'Competitor_4',
          addOns: [
            "C3Probiotic", "Fat-free", "Extra Caffiene", "Added Artificial Flavour"
          ]
        }
      ]
    };
  }
  componentDidMount() {

    if (this.props.showProductInfo) {
      fetch(config.api.url + "getAddOns/" + config.scenarioId, {
        // HUD to get pricing data when the HUD switches from one tab to another
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: `${config.token}`,
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          return response.json();
        })
        .then(addOns => {
          this.setState({
            data: this.props.data,
            colors: this.props.colors,
            addOns: addOns
          });
        });
    }
    else {
      this.setState({
        data: this.props.data,
        colors: this.props.colors
      });
    }
  }

  componentDidUpdate(oldProps) {
    this.loadBarChart(); // Function for loading the bar chart
  }

  loadBarChart() {
    if (this.props.data.length > 0) {
      let showInfo = this.props.showProductInfo
      let addOnData = [], showDataLabel
      showDataLabel = !this.props.tooltip
      if (showInfo) {
        addOnData = this.state.addOns
        showDataLabel = true
      }
      // If there is data
      Highcharts.chart(this.refs.horizontalBar, {
        chart: {
          // Chart Options
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "bar",
          backgroundColor: this.props.color,
          scrollablePlotArea: true
        },
        title: {
          // Title Options
          text: this.props.title || this.state.title,
          style: {
            fontSize: "0.9rem",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          // Tooltip Options
          enabled: this.props.tooltip,
          useHTML: true,
          backgroundColor: 'rgba(255, 255, 255, 0.80)',
          positioner: function (boxWidth, boxHeight, point) {
            let chart = this.chart,
              plotTop = chart.plotTop,
              plotHeight = chart.plotHeight,
              distance = 12,
              x, y
            x = point.plotX
            y = point.plotY

            if (y + boxHeight > plotTop + plotHeight) {
              y = Math.max(plotTop, plotTop + plotHeight - boxHeight - distance);
            }

            return { x: x, y: y };
          },
          formatter: function () {
            if (showInfo) {
              let addOnList = addOnData.filter(a => a.name === this.point.name)[0].addOns
              return ` <b>${this.point.name}  <br/> Price: </b>  ${Highcharts.numberFormat(this.y, 2)}$ <br/> <b>Addons:</b> ` +
                `<ul>
                    ${
                  addOnList.map(i => {
                    let temp = i.split('_').join(' ')
                    temp = temp.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')
                    return (`<li>${temp}</li>`)
                  })
                  }
                  </ul>`.replace(new RegExp(',', 'g'), '');
            }
            return '<b>' + this.point.name + '</b>: ' + Highcharts.numberFormat(this.y, 2) + ' %';
          }
        },
        colors: this.state.colors,
        plotOptions: {
          series: {
            animation: false // Remove Animation
          },
          bar: {
            dataLabels: {
              enabled: showDataLabel,
              format: this.props.label,
              style: {
                color: "#4f412e",
                fontSize: "0.8rem",
                textOutline: "2px contrast"
              }
            },
            colorByPoint: true
          }
        },
        xAxis: {
          // xAxis Options
          type: "category",
          lineWidth: 0,
          tickWidth: 0,
          labels: {
            style: {
              fontSize: "0.7rem",
              color: "#6f7373"
            }
          }
        },

        yAxis: {
          // yAxis Options
          title: {
            text: this.props.yTitle,
            style: {
              fontSize: "0.7rem",
              color: "#6f7373"
            }
          },
          labels: {
            enabled: this.props.tooltip,
            style: {
              fontSize: "0.6rem",
              color: "#6f7373"
            }
          }
        },
        series: [
          {
            data: this.props.data, // data which comes from props
            showInLegend: false
          }
        ]
      });
    }
  }

  render() {
    if (this.props.data.length > 0) {
      // If there is data
      return (
        <div
          style={{
            width: "100%",
            margin: "0 auto",
            height: "100%",
            minHeight: "15vh",
            borderBottomLeftRadius: "5px"
          }}
          ref='horizontalBar'
        />
      );
    }

    // If there is no data
    else {
      return <div className='noSimText'>No data available for bar chart</div>;
    }
  }
}

export default HorizontalbarChart;
